import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewArticleHighlightProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ViewArticleHighlight: React.FC<ViewArticleHighlightProps> = ({ entities }) => (
  <div className={`ArticleHighlight ${entities.size === 0 ? 'hidden' : ''}`}>
    <div className="row">
      {
        entities.map((entity) => {
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const key = `${uuid}:${langcode}`;

          return (
            <div key={uuid} className="col-12">
              <Node
                key={key}
                entity={entity}
                viewMode="teaser"
                large
                classes="ArticleTeaser--slide"
              />
            </div>
          );
        })
      }
    </div>
  </div>
);

export default ViewArticleHighlight;
